import RatePlanCalculationTypeEnum from '@constants/enums/ratePlan/calculationType';
import RatePlanStatusEnum from '@constants/enums/ratePlan/status';
import RatePlanTypeEnum from '@constants/enums/ratePlan/type';

import i18n from '@plugins/i18n';

import Collection from '@/models/Collection';
import RatePlan from '@/models/RatePlan';

export class SystemRatePlanCollection extends Collection {
    static type = 'SystemRatePlanCollection';
    static endpoint = RatePlan.api.index;
    static model = RatePlan;

    get default_headers() {
        return ['name', 'type', 'calculation_type', 'status', 'default', 'subscription_count', 'adviser_id'];
    }

    get preset_filters() {
        return {
            statistics: true
        };
    }

    get preset_sort_by() {
        return ['name:asc'];
    }

    get headers() {
        return [
            this.createHeader('control', '', {
                format: 'control',
                width: '3rem',
                persistent: true
            }),
            this.createHeader('name', i18n.t('name'), {
                filterable: true,
                width: '16rem'
            }),
            this.createHeader('type', i18n.t('_page.rate_plan.type'), {
                format: 'enum',
                filterable: true,
                enum: RatePlanTypeEnum,
                enumA11yKey: 'enums.rate_plan_type',
                width: '8rem'
            }),
            this.createHeader('calculation_type', i18n.t('_page.rate_plan.calculation_type'), {
                format: 'enum',
                filterable: true,
                enum: RatePlanCalculationTypeEnum,
                enumA11yKey: 'enums.rate_plan_calculation_type',
                width: '9rem'
            }),
            this.createHeader('status', i18n.t('status'), {
                format: 'enum',
                filterable: true,
                enum: RatePlanStatusEnum,
                enumA11yKey: 'enums.rate_plan_status',
                width: '8rem'
            }),
            this.createHeader('default', i18n.t('_page.rate_plan.default'), {
                format: 'boolean',
                width: '7rem'
            }),
            this.createHeader('subscription_count', i18n.t('_page.rate_plan.subscriptions'), {
                format: 'number',
                width: '8rem',
                filterable: false,
                sortable: false
            }),
            this.createHeader('adviser_id', i18n.t('adviser'), {
                width: '14rem',
                filterable: {
                    operators: this.getOperators(['eq']),
                    component: () => import('@/components/fields/Adviser.vue')
                },
                transform: data => data.item?.adviser?.name
            })
        ];
    }
}

export default SystemRatePlanCollection;
